export default __webpack_public_path__ + "static/media/bg6.75453607.jpg";